import { DOCUMENT } from '@angular/common';
import { inject, provideAppInitializer } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

export type EnvironmentName = 'test' | 'prod';

export const TEST_ENVIRONMENT_BODY_CLASS = 'env-test';
export const TEST_ENVIRONMENT_TITLE_PREFIX = '[TEST] ';
export const TEST_ENVIRONMENT_FAVICON = '/favicon-test.svg';

export function isTestEnvironment(name: EnvironmentName = environment.name): boolean {
    return name !== 'prod';
}

/**
 * Kennzeichnet die Testumgebung wie das Keycloak-Theme "cnf-test":
 * Body-Klasse (Platz fuer den Banner), Titel-Praefix "[TEST]" und oranges Favicon.
 * In Prod bleibt alles unveraendert.
 */
export function applyEnvironmentIndicator(document: Document, title: Title, name: EnvironmentName = environment.name): void {
    if (!isTestEnvironment(name)) {
        return;
    }

    document.body.classList.add(TEST_ENVIRONMENT_BODY_CLASS);

    if (!title.getTitle().startsWith(TEST_ENVIRONMENT_TITLE_PREFIX)) {
        title.setTitle(TEST_ENVIRONMENT_TITLE_PREFIX + title.getTitle());
    }

    document.querySelectorAll<HTMLLinkElement>('link[rel~="icon"]').forEach((link) => link.remove());
    const favicon = document.createElement('link');
    favicon.rel = 'icon';
    favicon.type = 'image/svg+xml';
    favicon.href = TEST_ENVIRONMENT_FAVICON;
    document.head.appendChild(favicon);
}

export const provideEnvironmentIndicator = () => provideAppInitializer(() => applyEnvironmentIndicator(inject(DOCUMENT), inject(Title)));
